import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { ActionListItem } from '../Components/GenericTable/GenericTableActions';

export const candidateSourcingActionsList: ActionListItem[] = [
  {
    id: 'delete',
    tooltipLabel: 'Delete Search',
    icon: <DeleteIcon />
  }
];

export const candidatePoolsActionsList: ActionListItem[] = [
  {
    id: 'delete',
    tooltipLabel: 'Delete Pool',
    icon: <DeleteIcon />
  }
];
